import { useState, useRef } from "react";

const ProfileImageContainer = ({ player, club, backup, alt, extraClasses }) => {
  const [errors, setErrors] = useState(0);
  const imgRef = useRef(null); // Store a reference to the image element to prevent runtime error

  const backups = [
    `https://buiha.org.uk/assets/img/profile/player-${backup}.jpg`,
    `https://buiha.org.uk/assets/img/profile/player-buiha.jpg`,
  ];
  const [currentSrc, setCurrentSrc] = useState(
    `https://buiha.org.uk/assets/img/profile/${club != null ? club : 0}/player-${player}.jpg`
  );

  const handleError = () => {
    setErrors((prevErrors) => {
      if (prevErrors < backups.length) {
        const nextSrc = backups[prevErrors];

        if (imgRef.current && imgRef.current.src !== nextSrc) {
          setCurrentSrc(nextSrc); // Prevent looping
          imgRef.current.src = nextSrc;
          return prevErrors + 1;
        }
      }
      return prevErrors;
    });
  };

  return (
    <div className="relative w-full h-full overflow-hidden flex justify-center items-center">
      <div className="absolute inset-0">
        <img
          ref={imgRef} // Use ref
          src={currentSrc}
          alt={`${alt} ${errors}`}
          className={`w-full h-full object-cover ${extraClasses}`}
          onError={handleError}
        />
      </div>
    </div>
  );
};

export default ProfileImageContainer;
